<template>
  <div class="navbar-brand-box">
    <nuxt-link to="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="/images/pijace-60.png" alt="logo-sm" height="60" width="60" />
      </span>
      <span class="logo-lg">
        <img src="/images/pijace-60.png" alt="logo-dark" height="60" width="60" />
      </span>
    </nuxt-link>

    <nuxt-link to="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="/images/pijace-60.png" alt="logo-sm" height="60" width="60" />
      </span>
      <span class="logo-lg">
        <img src="/images/pijace-60.png" alt="logo-light" height="60" width="60" />
      </span>
    </nuxt-link>
  </div>
</template>
